<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    document.title = this.$t('common.documentTitle')
    this.$store.commit("setMobileSize", document.documentElement.clientWidth <= 767);
  },
  mounted() {
    window.onresize = () => {
      this.$store.commit("setMobileSize", document.documentElement.clientWidth <= 767);
    };
  },
}
</script>
